import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { SpinnerModule } from '@uiowa/spinner';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MfkTableComponent } from './mfk/mfk.component';
import { WindowRefService } from './services/window.service';

@NgModule({
  imports: [CommonModule, NgbModule, FormsModule, SpinnerModule, FontAwesomeModule],
  declarations: [MfkTableComponent],
  exports: [CommonModule, NgbModule, FormsModule, SpinnerModule, FontAwesomeModule, MfkTableComponent],
  providers: [WindowRefService]
})
export class SharedModule {}
